import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridAuditSettings {

  constructor(private translate: TranslateService) { }

    public agGridAuditSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 55,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      { 
        field: 'action', 
        headerName: "Aktion", 
        sortable: true, 
        filter: true, 
        tooltipValueGetter: (params: any) => {
            return this.getToolTipAction(params.value);
        },
        //        tooltipValueGetter: (params: ICellRendererParams) => this.getToolTip(_.get(params.data, 'action', ''))
      },
      { field: 'grouprolE_NAME', headerName: "Rolle", sortable: true, filter: true },
      { field: 'projecT_NAME', headerName: "Projekt", sortable: true, filter: true },
      { field: 'creatoR_NAME', headerName: "Erstellt von", sortable: true, filter: true },
      { 
        field: 'createD_WHEN', 
        headerName: "Erstellt am", 
        sortable: true, 
        filter: false,
        valueFormatter: (params: any) => {
          if (!params.value) return '';
          const date = new Date(params.value);
            return date.toLocaleDateString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        }
      },
      { 
        headerName: "Benutzer", 
        sortable: true, 
        filter: true,
        // field: 'useR_NAME', 
        valueGetter: (params: any) => {
          const userName = _.get(params.data, 'useR_NAME', '');
          return userName !== ' (not confirmed)' ? userName : _.get(params.data, 'useR_EMAIL', '');
        },
        //tooltipField: 'useR_EMAIL'
        tooltipValueGetter: (params: any) => {
          return this.getToolTipUserName(params.value, params);
        },
      },
      { 
        headerName: "Aktuelle Daten", 
        sortable: true, 
        filter: true,
        valueGetter: (params: any) => {
          return this.getValue(_.get(params.data, 'acT_PERMISSIONS', ''));
        },
        tooltipValueGetter: (params: any) => {
          return this.getTooltipValue(_.get(params.data, 'acT_PERMISSIONS', ''));
        },
        // wrapText: true, autoHeight: true,
        // cellStyle: { 'white-space': 'pre-wrap' }
        //cellRendererParams: (params: ICellRendererParams) => this.formatToolTip(_.get(params.data, 'acT_PERMISSIONS', ''))
      },
      {
        headerName: "Vorherige Daten", 
        sortable: true, 
        filter: true,
        valueGetter: (params: any) => {
          return this.getValue(_.get(params.data, 'preV_PERMISSIONS', ''));
        },
        tooltipValueGetter: (params: any) => {
          return this.getTooltipValue(_.get(params.data, 'preV_PERMISSIONS', ''));
        },
        // tooltipComponentParams: {
        //   cssClass: 'ag-tooltip-multi-line',
        // }
      },
          // { field: 'acT_PERMISSIONS', headerName: "Aktuelle Daten", sortable: true, filter: true, tooltipField: 'acT_PERMISSIONS' },
          // { field: 'preV_PERMISSIONS', headerName: "Vorherige Daten", sortable: true, filter: true, tooltipField: 'preV_PERMISSIONS' },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }
  getToolTipAction(action: string): string {
    // const action = _.get(params.data, 'action', '');
    if (action === 'UpdTGR') {
      return 'Mandantengruppenrolle wurde geändert';
    } else if (action === 'RemFromTGR') {
      return 'Benutzer wurde aus der Mandantengruppenrolle entfernt';
    } else if (action === 'AssToTGR') {
      return 'Benutzer wurde zur Mandantengruppenrolle hinzugefügt';        
    } else if (action === 'UpdPGR') {
      return 'Projektgruppenrolle wurde geändert';
    } else if (action === 'RemFromPGR') {
      return 'Benutzer wurde aus der Projektgruppenrolle entfernt';         
    } else if (action === 'AssToPGR') {
      return 'Benutzer wurde zur Mandantengruppenrolle hinzugefügt';        
    } else if (action === 'TenantMod') {
      return 'Module für Mandant wurden geändert';        
    } else if (action === 'ProjectMod') {
      return 'Module für Projekt wurden geändert';        
    } else if (action === 'AssUser') {
      return 'Benutzer wurde reaktiviert';        
    } else if (action === 'RemUser') {
      return 'Benutzer wurde deaktiviert';        
    } else return 'Unbekannte Aktion';
      //return `E-Mail: ${userEmail}`;
  }
  getToolTipUserName(name: string, params: any): string {
    //console.log("-----------> Benutzername: ", name);
    return name.includes('@') ? 'Benutzer hatte E-Mail zu diesem Zeitpunkt nicht bestätigt' : _.get(params.data, 'useR_EMAIL', '');
  }
  getValue(rawContent: string): string {
    //console.log("-----------> rawContent for Value: ", rawContent);
    if (rawContent === '[]' || rawContent === undefined || rawContent === null) {
      return '';
    } else if (rawContent.charAt(0) === '[') {
      const modulesArray = JSON.parse(rawContent);
      const moduleNames = modulesArray.map((module: any) => module.moduleName);
      return moduleNames.join(', ');
    } else {
      return rawContent;
    }
  }
  getTooltipValue(rawContent: string): string {
    //console.log("-----------> rawContent for Tooltip: ", rawContent);
    if (rawContent === '[]' || rawContent === undefined || rawContent === null) {
      return '';
    } else if (rawContent.charAt(0) === '[' && !rawContent.includes('count')) {
      const modulesArray = JSON.parse(rawContent);
      const moduleNames = modulesArray.map((module: any) => module.moduleName);
      return moduleNames.join(', ');
    } else if (rawContent.charAt(0) === '[') {
      const modulesArray = JSON.parse(rawContent);
      const moduleDetails = modulesArray.map((module: any) => `Modul: ${module.moduleName}, Gebucht: ${module.count}`);
      //console.log("-----------> moduleDetails: ", moduleDetails.join('\n'));
      return moduleDetails.join(' | ');
    } else {
      return rawContent;
    }
  }
  formatToolTip(rawContent: any) {
    // USE THIS FOR TOOLTIP LINE BREAKS
    // const first = _.get(rawContent, 'fName', '');
    // const last = _.get(rawContent, 'lName', '');
    const first = "1.Zeile";
    const last = "2.Zeile";
    const lineBreak = true;
    const toolTipArray = [first, last]
    return { toolTipArray, lineBreak }

    // USE THIS FOR SINGLE LINE TOOLTIP

    // const lineBreak = false;
    // const toolTipString = 'Hello World'
    // return { toolTipString, lineBreak }
  }
}
